import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import { InMemoryCache } from '@apollo/client/cache'
import store from '@/store'
import { defaultTracer } from '@/plugins/opentelemetry.js'

// import NProgress from 'nprogress'

const createEndpointLink = (uri) => {
  return new HttpLink({ uri })
}

const createAuthLink = () => {
  return new ApolloLink((operation, forward) => {
    const token = localStorage.getItem(store.getters['user/tokenKey'])
    const esbType = localStorage.getItem('x-esb-type')

    operation.setContext({
      headers: {
        ...operation.getContext().headers,
        authorization: token ? `TproSID ${token}` : '',
        'X-ESB-Type': esbType
      }
    })

    return forward(operation)
  })
}

const createErrorLink = () => {
  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    const { trace: { span } } = operation.getContext()

    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) => {
        span.setStatus({ code: 2, message: message }) // последняя ошибка?
        console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      })
    }

    if (networkError) {
      span.setStatus({ code: 2, message: networkError })
      console.error(`[Network error]: ${networkError}`, networkError.status)
      if (networkError.statusCode === 401 || networkError.statusCode === 403) {
        // с авторизацией проблемы, дропаем весь стейт иперегружаем страницу
        span.end()
        location.reload()
      }
    }

    return forward(operation)
  })
}

const createTraceLink = () => {
  return new ApolloLink((operation, forward) => {
    const user = store.getters['user/user']

    const span = defaultTracer.startSpan(operation.operationName)
    span.setAttribute('url', window.location.href)
    span.setAttribute('VUE_APP_MODE', process.env.VUE_APP_MODE)
    span.setAttribute('VUE_APP_DOMAINS', process.env.VUE_APP_DOMAINS)
    span.setAttribute('ESB Type', localStorage.getItem('x-esb-type'))
    span.setAttribute('user_name', user?.fullName)
    span.setAttribute('user_id', user?.id)
    span.setAttribute('user_company_id', user?.companyId)
    span.setAttribute('user_company_title', user?.companyTitle)

    operation.setContext({
      headers: {
        ...operation.getContext().headers,
        traceparent: `1.0-${span.spanContext.traceId}-${span.spanContext.spanId}-${span.spanContext.traceFlags}`
      },
      trace: { span }
    })

    return forward(operation).map(response => {
      span.end()
      return response
    })
  })
}

export const backendClient = new ApolloClient({
  link: createTraceLink()
    .concat(createErrorLink())
    .concat(createAuthLink())
    .concat(createEndpointLink(process.env.VUE_APP_BACKEND_GQL_ENDPOINT)),
  cache: new InMemoryCache({
    addTypename: true
  }),
  connectToDevTools: true,
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    }
  }
})

export const contractClient = new ApolloClient({
  link: createTraceLink()
    .concat(createErrorLink())
    .concat(createAuthLink())
    .concat(createEndpointLink(process.env.VUE_APP_CONTRACT_GQL_ENDPOINT)),
  cache: new InMemoryCache({
    addTypename: true,
    possibleTypes: {
      Field: ['IntegerField', 'StringField', 'DatetimeField', 'BooleanField', 'FloatField', 'DecimalField']
    }
  }),
  connectToDevTools: true,
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    }
  }
})

export const apolloProvider = new VueApollo({
  defaultClient: backendClient,
  clients: {
    backendClient,
    contractClient
  }
})

Vue.use(VueApollo)
